import { axiosV2 } from 'interceptors/axios';
import {
  PageActivityAction,
  PageActivityActions,
  PageActivityFeature,
  PageActivityLevel,
} from 'constants/pageActivityFeatures';

export type PageActivityPayload = {
  feature: PageActivityFeature;
  action: PageActivityAction;
  level?: PageActivityLevel;
  societyId?: string;
  societyName?: string;
  userId?: string;
  userEmail?: string;
  userName?: string;
  userRole?: string;
  partnerId?: string;
  sectionIndex?: number;
  sectionTitle?: string;
  folderIndex?: number;
  folderTitle?: string;
  contentId?: string;
  contentTitle?: string;
  contentType?: string;
};

const trackPageActivity = (payload: PageActivityPayload): void => {
  if (!payload?.feature || !payload?.action) return;

  axiosV2.post('/track-page-activity', payload)?.catch?.(() => {});
};

export default trackPageActivity;
